module.exports = __webpack_public_path__ + "img/delete-icon-disabled.dfa5a2ef.svg";